import { render, staticRenderFns } from "./AlertingRules.vue?vue&type=template&id=5b66d722&scoped=true"
import script from "./AlertingRules.vue?vue&type=script&lang=js"
export * from "./AlertingRules.vue?vue&type=script&lang=js"
import style0 from "./AlertingRules.vue?vue&type=style&index=0&id=5b66d722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66d722",
  null
  
)

export default component.exports